import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import BaseInput from './BaseInput';
import BaseInputProps from './BaseInputProps';

export interface Option {
  value: string;
  label: string;
}

export interface SelectInputProps extends BaseInputProps {
  options?: Option[];
  placeholder?: string;
  inputProps?: JSX.IntrinsicElements['select'];
  allowBlank?: boolean;
}

export default function SelectInput({
  options = [],
  placeholder = 'Select an option...',
  inputProps,
  allowBlank = false,
  ...baseProps
}: SelectInputProps) {
  const { name } = baseProps;

  const { register } = useFormContext();
  const [isFocused, setIsFocused] = useState(false);

  return (
    <BaseInput isFocused={isFocused} {...baseProps}>
      <select
        {...register(name)}
        id={name}
        name={name}
        className="mt-2 text-base p-2 mr-3 pr-12 block w-full rounded-md border-0 text-limed-spruce-800 shadow-sm ring-1 ring-inset ring-porcelain-300 placeholder:text-porcelain-400 focus:ring-2 focus:ring-inset focus:ring-bondi-blue-600"
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        {...inputProps}
      >
        <option value="" disabled={!allowBlank}>{placeholder}</option>
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </BaseInput>
  );
}
